var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookSavedActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/book-saved"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-saved"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3334 3.89174V13.9501C18.3334 14.7501 17.6834 15.5001 16.8834 15.6001L16.6083 15.6334C14.7917 15.8751 11.9917 16.8001 10.3917 17.6834C10.175 17.8084 9.8167 17.8084 9.59169 17.6834L9.55833 17.6668C7.95833 16.7918 5.16671 15.8751 3.35838 15.6334L3.11668 15.6001C2.31668 15.5001 1.66669 14.7501 1.66669 13.9501V3.8834C1.66669 2.89173 2.475 2.14174 3.46666 2.22508C5.21666 2.36674 7.86666 3.2501 9.35 4.1751L9.55833 4.30007C9.8 4.45007 10.2 4.45007 10.4417 4.30007L10.5834 4.20841C11.1084 3.88341 11.775 3.55841 12.5 3.26674V6.66676L14.1667 5.55841L15.8334 6.66676V2.31678C16.0584 2.27511 16.275 2.25008 16.475 2.23342H16.525C17.5167 2.15008 18.3334 2.89174 18.3334 3.89174Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 4.5752V17.0752",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.8333 2.31689V6.66687L14.1667 5.55852L12.5 6.66687V3.26686C13.5917 2.83352 14.8083 2.48356 15.8333 2.31689Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookSavedActive);
export default __webpack_public_path__ + "static/media/book-saved-active.019f87fb0b8f6fd310b28dbaac5dd187.svg";
export { ForwardRef as ReactComponent };